<i18n lang="json">
    {
      "ru": {
        "safe_deposit_box_rental": "Банковские сейфы (сейфовые ячейки)",
        "dont_store_skeletons": "Безопасно хранить, удобно пользоваться",
        "calculate": "Рассчитать",
        "safe": "Конфиденциальность и безопасность",
        "safe_text": "доступ к ячейке есть только у арендатора.",
        "accessible": "Полная защита",
        "accessible_text": "ячейки расположены в специально оборудованных хранилищах, соответствующих высоким стандартам безопасности.",
        "flexible_rates": "Гибкие условия аренды",
        "flexible_rates_text": "возможность выбрать удобный срок хранения от 1 месяца до 1 года.",
        "residents":"Доступ для резидентов и нерезидентов",
        "residents_text":"арендовать ячейку могут как граждане Абхазии, так и граждане РФ."
      },
      "en": {
        "safe_deposit_box_rental": "Bank safes (safe deposit boxes)",
        "dont_store_skeletons": "Safe to store, convenient to use",
        "calculate": "Calculate",
        "safe": "Safe",
        "safe_text": "We have the most modern security and fire protection measures",
        "accessible": "Accessible",
        "accessible_text": "Individuals, legal entities, sole proprietors - there's a safe for everyone",
        "flexible_rates": "Flexible Rates",
        "flexible_rates_text": "Longer rental term - lower daily cost",
        "residents":"Access for residents and non-residents",
        "residents_text":"Both citizens of Abkhazia and citizens of the Russian Federation can rent a cell."
      },
      "tr": {
        "safe_deposit_box_rental": "Banka kasaları (kiralık kasalar)",
        "dont_store_skeletons": "Saklanması güvenli, kullanımı rahat",
        "calculate": "Hesapla",
        "safe": "Güvenli",
        "safe_text": "En modern güvenlik ve yangın koruma önlemlerine sahibiz",
        "accessible": "Erişilebilir",
        "accessible_text": "Bireyler, tüzel kişiler, tek mülkiyet sahipleri - herkes için bir kasa var",
        "flexible_rates": "Esnek Tarifeler",
        "flexible_rates_text": "Daha uzun kiralama süresi - daha düşük günlük maliyet",
        "residents":"Yerleşikler ve yerleşik olmayanlar için erişim",
        "residents_text":"Hem Abhazya vatandaşları hem de Rusya Federasyonu vatandaşları hücre kiralayabilir."
      },
      "es": {
        "safe_deposit_box_rental": "Cajas fuertes bancarias (cajas de seguridad)",
        "dont_store_skeletons": "Seguro de almacenar, cómodo de usar",
        "calculate": "Calcular",
        "safe": "Seguro",
        "safe_text": "Tenemos las medidas de seguridad y protección contra incendios más modernas",
        "accessible": "Accesible",
        "accessible_text": "Personas físicas, entidades legales, propietarios únicos - hay una caja fuerte para todos",
        "flexible_rates": "Tarifas Flexibles",
        "flexible_rates_text": "Cuanto más largo sea el período de alquiler, menor será el costo diario",
        "residents":"Acceso para residentes y no residentes",
        "residents_text":"Tanto los ciudadanos de Abjasia como los ciudadanos de la Federación de Rusia pueden alquilar una celda."
      },
      "ar": {
        "safe_deposit_box_rental": "خزائن البنوك (صناديق الأمانات)",
        "dont_store_skeletons": "آمنة للتخزين ومريحة للاستخدام",
        "calculate": "احسب",
        "safe": "آمن",
        "safe_text": "لدينا أحدث وسائل الأمن والحماية من الحرائق",
        "accessible": "متاح",
        "accessible_text": "الأفراد، الكيانات القانونية، الملاك الوحيدون - هناك صندوق آمن للجميع",
        "flexible_rates": "أسعار مرنة",
        "flexible_rates_text": "كلما طالت مدة الإيجار، انخفضت التكلفة اليومية",
        "residents":"الوصول للمقيمين وغير المقيمين",
        "residents_text":"يمكن لكل من مواطني أبخازيا ومواطني الاتحاد الروسي استئجار خلية."
      }
    }
    </i18n>
    
    <template>
        <section class="bg-gray relative lg:pt-0 sm:pt-10 pt-5 sm:pb-0 pb-5 overflow-hidden">
            <div class="container px-4 lg:px-0">
                <div class="flex items-center justify-between sm:h-120 sm:relative">
                    <div class="grid gap-5 lg:gap-10">
                        <div class="grid gap-3">
                            <p class="text-3xl sm:text-4xl font-semibold">{{ t('safe_deposit_box_rental') }}</p>
                            <p class="text-base sm:text-xl">{{ t('dont_store_skeletons') }}</p>
                        </div>
                        <div class="grid lg:grid-cols-2 grid-cols-1 relative">
                            <div v-for="(step, index) in steps" :key="index" class="relative items-center w-[280px]">
                                <div class="mt-5 grid gap-[7px] ml-5 md:ml-[30px]">
                                    <p class="z-10 font-semibold text-sm sm:text-xl ">{{ t(step.title) }}</p>
                                    <p class="z-10 text-sm sm:text-base">{{ t(step.text) }}</p>
                                </div>
                                <div
                                    class="absolute top-2 sm:top-0 z-0 rounded-full border-2 border-darkYellow h-9 sm:h-17 w-9 sm:w-17">
                                </div>
                            </div>
                        </div>
                        <a href="#rental"><AButton width="medium" class="hidden lg:block">{{ t('calculate') }}</AButton></a>
                        
                        <div class="absolute sm:right-0 sm:bottom-0 -right-36 -bottom-0 z-0">
                            <a-icon-lockbox
                                class="h-60 sm:h-full sm:max-h-90"></a-icon-lockbox></div>
                    </div>
                </div>
            </div>
        </section>
    </template>
    
    <script setup>
    const { t } = useI18n({ useScope: 'local' });
    const steps = ref([
        {
            title: 'safe',
            text: 'safe_text',
        }, 
         {
            title: 'flexible_rates',
            text: 'flexible_rates_text',
        },
        {
            title: 'accessible',
            text: 'accessible_text',
        },
      
        {
            title: 'residents',
            text: 'residents_text',
        },
    ]);
    </script>